import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { Config } from 'app/_helper/config';
import { timeout } from 'q';

export abstract class BaseService {
  
    private static context = 'EXAME';
    private static credentialKey = 'CURRENT_USER';
    public onLogoff: Subject<void>;
    public onLogon: Subject<void>;
    public onEstabelecimentoChanged: Subject<void>;

    protected http: HttpClient;
    protected url: string;    
    protected baseUrl: string;
  
  private getStorageMode(): boolean
  { return localStorage.getItem('remember') == 'S'; }


  protected  setStorageMode(remember: boolean): void
  { localStorage.setItem('remember', ((remember) ? 'S' : 'N')); }

  protected saveStorage(key:string, value:string): void
  { (this.getStorageMode()) ? localStorage.setItem( BaseService.context +  '.' + key, value ) :  sessionStorage.setItem( BaseService.context +  '.' + key, value ); }

  protected getStorage(key:string)
  { return (this.getStorageMode()) ? localStorage.getItem( BaseService.context +  '.' + key ) : sessionStorage.getItem( BaseService.context +  '.' + key ); }

  private static _getUser = null;
  public getUser()
  { 
    if(BaseService._getUser == null)
    {
      BaseService._getUser = JSON.parse(this.getStorage( BaseService.credentialKey));
      if(BaseService._getUser != null)
      {
        this.onLogon.next(BaseService._getUser);
        this.onLogon.complete();
      }
    }
    return  BaseService._getUser; 
  }

  constructor(ctx: string, baseUrl: string) {
    this.baseUrl = baseUrl;
    this.onEstabelecimentoChanged = new Subject();
    this.onLogoff = new  Subject();
    this.onLogon = new Subject();
  }

  RefreshToken(IdEstabelecimento) {

    return new Observable((obs) => {
      
      const d = this.getUser();
      const opts = { headers: new HttpHeaders( { 'Content-Type': 'x-www-form-urlencoded' }) };

      if (d == null || d.access_token == null)
      { obs.error("Não autenticado"); }
      else
      {
        const data =  encodeURIComponent("grant_type") + "=" + encodeURIComponent("refresh_token") + "&" + 
                      encodeURIComponent("refresh_token") + "=" + encodeURIComponent(d.refresh_token) + "&" + 
                      encodeURIComponent("client_id") + "=" + encodeURIComponent(Config.info.apiServer.auth.key) + "&" + 
                      encodeURIComponent("client_secret") + "=" + encodeURIComponent(Config.info.apiServer.auth.pwd) + "&" + 
                      encodeURIComponent("estabelecimento") + "=" + encodeURIComponent(IdEstabelecimento || '');

        this.http.post<any>(Config.info.apiServer.auth.url + 'token', data, opts)        
        .subscribe( res => {
          this.refresh(res);
          obs.next(res);
        },
        err => {
          this.logoff();
          obs.error(err);
        },
        () => obs.complete());  
      }
      });
  }

  private getRequestHeader()
  {
    var crd : any = this.getUser();
    
    if(crd != null)
    {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Authorization': `Bearer ${crd.access_token}`
        })
      };
    }
    else
    {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        })
      };
    }
  }
  private request<T>(fullUrl: string, data:any) : any
  { 
    return new Observable((obs)=>{
      this.http.post<T>(fullUrl,  data, this.getRequestHeader() )
      .subscribe(
        res => {
          obs.next(res);
          obs.complete();
        },
        err => {
           const usr = this.getUser();
           if ( err.status === 401 && usr != null )
           {
              return this.RefreshToken(usr.id_estabelecimento)
              .subscribe(
                refreshed => {
                  this.http.post<T>(fullUrl, data, this.getRequestHeader())
                  .subscribe(
                    res => {  obs.next(res); obs.complete(); },
                    err2 => { obs.error(err2); obs.complete(); }
                  );
                },
                err3 => {  
                  this.logoff();
                  obs.complete();
                }
              );
           }
           else
           { 
             obs.error(err); 
             obs.complete();
           }
        }
        ); 
    });
  }
  
  public send<T>( service:string, data:any )  : Observable<any>
  { return this.request<T>(this.baseUrl + this.url + service,  data); }
  
  public reloadAllCache()
  {
    let ss =  sessionStorage.getItem('cacheDictionary');
    if(ss)
    {
      let dic = JSON.parse(ss)
      for(let d in dic)
      {
        if(dic[d] != null)
        { dic[d].forEach(cacheName => sessionStorage.setItem(cacheName, null)); }
      }
    }
  }

  public reloadCache()
  {
    let ss =  sessionStorage.getItem('cacheDictionary');
    if(ss)
    {
      let dic = JSON.parse(ss)
      if(dic[this.url] != null)
      { dic[this.url].forEach(cacheName => sessionStorage.setItem(cacheName, null)); }
    }
  }

  public cachedSend(service:string, data):Observable<any>
  {
    let sub = new Subject<any>();

    setTimeout(() => {
        
        let cacheName =  `${this.getUser().id}:${this.url + service}:${JSON.stringify(data).toLowerCase()}`;
        
        let ss =  sessionStorage.getItem('cacheDictionary');
        let dic : any = (ss) ? JSON.parse(ss) : {};

        if(dic[this.url] == null)
        { dic[this.url] = [cacheName]; }
        else if( dic[this.url].indexOf(cacheName) == -1 )
        { dic[this.url].push(cacheName); }
        
        sessionStorage.setItem('cacheDictionary', JSON.stringify(dic));

        let itm = sessionStorage.getItem(cacheName);

        if(itm != null && itm != "null")
        { 
          sub.next( JSON.parse(itm) ); 
          sub.complete();
        }
        else
        {
          this.send(service, data)
          .subscribe( res => {
              sessionStorage.setItem(cacheName, (res != null)?JSON.stringify(res):null);
              sub.next(res);
              sub.complete();
             
            }, 
          err=> sub.error(err)
          );
        }
    }, 1);
    
    return sub.asObservable();

  }

  public list( filter:any )
  { return this.send<any>('list',  filter); }

  public listCached( filter:any )
  { return this.cachedSend('list',  filter); }

  private currentFilter:any;
  public search(filter:any, page = 0)
  {  
    const size:number = 20;
    this.currentFilter = filter || this.currentFilter;
    return this.send<any>('getall',  { config: { Skip: page, Top: size }, Filter: this.currentFilter }); 
  }

  public post(form)
  { 
    this.reloadCache();
    return this.send<any>('post',  form); 
  }

  public put(form)
  { 
    this.reloadCache();
    return this.send<any>('put',  form); 
    
  }

  public delete(key)
  { 
    this.reloadCache();
    return this.send<any>('delete',  key); 
  }

  public get(key)
  { return this.send<any>('get',  key); }

  
  protected refresh(credential:any)
  { 
    this.reloadAllCache();
    BaseService._getUser = credential;
    this.saveStorage( BaseService.credentialKey, JSON.stringify(credential) );
    this.onEstabelecimentoChanged.next( credential.id_estabelecimento );
  }

  protected auth(credential:any)
  { 
    BaseService._getUser = credential
    this.saveStorage( BaseService.credentialKey, JSON.stringify(credential) ); 
    this.onLogon.next();
  }

  logoff()
  { 
    BaseService._getUser = null;
    this.saveStorage( BaseService.credentialKey, null ); 
    this.onLogoff.next();
  }
}


